module.exports = __webpack_public_path__ + "static/media/configurations.83656f25.xlsx";